var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{staticClass:"upload-demo",attrs:{"action":_vm.actionUrl,"accept":"image/jpg,image/jpeg,image/png","on-success":_vm.handleSuccess,"show-file-list":false,"file-list":_vm.imgList,"headers":_vm.postHeader,"limit":1}},[_c('el-button',{attrs:{"size":"small"}},[_vm._v(_vm._s(_vm.btnTitle))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }